import React from "react";
import styled from "styled-components";

const StyledWrapper = styled.div`
  position: relative;
  margin-left: -50vw;
  left: 50%;
  width: 100vw;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(auto auto);
  align-items: center;
  /* padding: 0.5rem; */
  text-align: center;
  transition: var(--transition);
  border-top: "none";

  & > * {
    display: flex;
    /* border: 1px solid black; */
    height: 100%;
    width: 100%;
    text-align: center;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    /* align-items: stretch; */
    border-top: var(--border-width-hard) solid
      ${({ theme }) => theme.colors.dborder};
    border-bottom: var(--border-width-hard) solid
      ${({ theme }) => theme.colors.dborder};
    /* padding: 1em 0; */
    padding: 1em;
    /* transition: var(--transition); */
  }

  ul {
    ${({ theme }) => theme.mixins.components.list}
    text-align: start;
  }

  & > :nth-child(1) {
    border-bottom: none;
  }

  @media (min-width: 800px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;

    & > * {
      padding: 2.5em;
    }
    & > :nth-child(1) {
      border-bottom: var(--border-width-hard) solid
        ${({ theme }) => theme.colors.dborder};
      border-right: var(--border-width-hard) solid
        ${({ theme }) => theme.colors.dborder};
    }
  }
`;

const QuickInfo = ({ children }: any) => {
  return <StyledWrapper>{children}</StyledWrapper>;
};

export default QuickInfo;
